import React from 'react';
import config from '../config';
import { formatEur, seasonForDate } from '../utils/pricing';
import { todayKey } from '../utils/dates';
import Reveal from './Reveal';
import './Pricing.css';

const seasonDetails = [
  {
    key: 'low',
    monthsLabel: 'november – apríl',
    note: 'Zimné výlety, útek pred mrzkou košickou zimou.',
  },
  {
    key: 'mid',
    monthsLabel: 'máj, jún, september, október',
    note: 'Najkrajšie mesiace na cesty bez davov.',
  },
  {
    key: 'high',
    monthsLabel: 'júl – august',
    note: `2. a každý ďalší týždeň len ${formatEur(config.highSeasonLongStayPrice)}/deň.`,
  },
];

/** Sezónny cenník. Ceny sa upravujú v src/config.js.
 *  Zvýraznená je vždy sezóna, do ktorej patrí dnešný dátum. */
export default function Pricing() {
  const currentSeason = seasonForDate(todayKey());
  return (
    <section className="section" id="cennik">
      <div className="container">
        <Reveal className="section-heading">
          <span className="eyebrow">Cenník</span>
<section>
  <h2>Jednoduché sezónne ceny</h2>

  <p className="lead">
    Slovenská diaľničná známka a plná kempingová výbava sú v cene.
  </p>

  <ul>
    <li>Hlavná sezóna len 120 € za deň</li>
    <li>Od druhého týždňa dokonca 100 € za deň</li>
    <li>Vratná kaucia: 1 000 €</li>
    <li>
      Doplnky:
      <ul>
        <li>Nosič na štyri bicykle: 5 € za deň, najviac však 30 €</li>
        <li>Paddleboard: 5 € za deň, najviac 30 €</li>
      </ul>
    </li>
    <li>Minimálny prenájom: {config.minDays} dni</li>
  </ul>
</section>
        </Reveal>

        <div className="pricing">
          {seasonDetails.map((season, index) => {
            const data = config.seasons[season.key];
            const featured = season.key === currentSeason;
            return (
              <Reveal key={season.key} delay={index * 0.1}>
                <article className={`pricing__card ${featured ? 'pricing__card--featured' : ''}`}>
                  <h3>{data.label}</h3>
                  <p className="pricing__months">{season.monthsLabel}</p>
                  <p className="pricing__price">
                    {formatEur(data.price)}
                    <span> / deň</span>
                  </p>
                  <p className="pricing__note">{season.note}</p>
                  {featured && <p className="pricing__current">Aktuálna sezóna</p>}
                  <a href="#rezervacia" className={`btn ${featured ? 'btn--primary' : 'btn--ghost'}`}>
                    Vybrať termín
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="pricing__deposit">
            Pri prevzatí sa skladá <strong>vratná kaucia 1 000 €</strong>. Po bezproblémovom vrátení vozidla ju dostaneš v plnej výške späť. Vodič musí mať minimálne 25 rokov a vodičský preukaz B aspoň 5 rokov. Vozidlo sa prenajíma s plnou nádržou paliva a musí sa vrátiť s plnou nádržou.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
